import { Apple } from "lucide-react";
import { cn } from "@/lib/utils";

const GooglePlayIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M4 3.4v17.2a1 1 0 0 0 1.51.86l14.5-8.6a1 1 0 0 0 0-1.72L5.51 2.54A1 1 0 0 0 4 3.4z" />
  </svg>
);

// Non-clickable app store badge with a "Coming Soon" ribbon. aria-disabled so
// assistive tech announces it is not yet actionable.
export const StoreBadge = ({ store = "apple", testId, className = "" }) => {
  const isApple = store === "apple";
  return (
    <div
      role="button"
      aria-disabled="true"
      tabIndex={-1}
      data-testid={testId}
      title="Coming soon"
      className={cn(
        "relative inline-flex cursor-default select-none items-center gap-3 rounded-md bg-halalgo-ink px-5 py-2.5 text-white shadow-lift-sm ring-1 ring-black/10",
        className
      )}
    >
      {isApple ? (
        <Apple className="h-7 w-7" />
      ) : (
        <GooglePlayIcon className="h-6 w-6" />
      )}
      <span className="flex flex-col text-left leading-tight">
        <span className="text-[10px] font-medium uppercase tracking-wide text-white/70">
          {isApple ? "Download on the" : "Get it on"}
        </span>
        <span className="-mt-0.5 text-lg font-semibold">
          {isApple ? "App Store" : "Google Play"}
        </span>
      </span>
      <span className="absolute -right-2 -top-2 rounded-full bg-halalgo-kraft-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-halalgo-ink shadow">
        Soon
      </span>
    </div>
  );
};
